import Store from './Store'
import { flow, makeObservable, observable } from 'mobx'
import CalendarService from '../services/CalendarService'
import Event from '../models/Event'

class NextEventsStore extends Store {
  @observable events = []

  constructor () {
    super()
    this.isLoading = true
    makeObservable(this)
  }

  @flow
  * fetchNextEvent () {
    const result = yield CalendarService.getNextAppointments()
    this.events = []
    for (const event of result.event) {
      this.events.push(new Event(event))
    }
    this.isLoading = false
  }
}
export default NextEventsStore
